import { WalletIcon } from "@phosphor-icons/react/dist/csr/Wallet";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";

export const TechnicianPayrollUnavailable = () => (
  <Empty className={emptyStateVariants({ layout: "workspace" })}>
    <EmptyHeader className="max-w-md">
      <EmptyMedia variant="icon">
        <WalletIcon aria-hidden />
      </EmptyMedia>
      <EmptyTitle className="text-lg">
        <h1>No payroll to review</h1>
      </EmptyTitle>
      <EmptyDescription>
        Payroll is not available for this business in Volca. You can close this
        page.
      </EmptyDescription>
      <EmptyDescription>
        If you expected to see your pay, contact your business administrator.
      </EmptyDescription>
    </EmptyHeader>
  </Empty>
);
